import { Wifi, Zap, ScanEye, Save, Smartphone, Building } from 'lucide-react';
import SeriesTemplate from '../components/SeriesTemplate';

const WifiCamera = () => {
  const features = [
    {
      Icon: Wifi,
      title: 'WiFi接続で配線を最小限に',
      desc: 'LANケーブル配線が難しい既存の店舗・室内でも導入しやすい構成です。',
    },
    {
      Icon: Zap,
      title: '簡易な電源接続',
      desc: '一般的な電源コンセントから給電でき、大掛かりな工事なしに設置できます。',
    },
    {
      Icon: Smartphone,
      title: 'スマートフォンからの確認',
      desc: '外出先からアプリで映像を確認したい小規模店舗などに向いています。',
    },
    {
      Icon: ScanEye,
      title: '動体検知・通知',
      desc: '動きを検知したときに通知を受け取り、必要な確認だけ行うことができます。',
    },
    {
      Icon: Save,
      title: 'microSD対応',
      desc: '本体内のmicroSDに録画でき、必要に応じてクラウド保存も検討できます。',
    },
    {
      Icon: Building,
      title: '小規模施設向けの構成',
      desc: '本格的なNVR構成が不要な場面や、簡易確認用途に向いたシリーズです。',
    },
  ];

  const notes = [
    'WiFi環境の品質・電波状況により、映像の遅延・切断が発生する可能性があります。',
    '本格的な多台数構成や長時間録画が必要な場合は、有線IPカメラ+NVR構成をご検討ください。',
    '通信のセキュリティ設定を含め、導入前に環境を確認いたします。',
    '機種や設定内容により、使用できる機能が異なる場合があります。',
  ];

  return (
    <SeriesTemplate
      id="wifi"
      eyebrow="WIFI CAMERA"
      name="小規模施設・WiFiカメラシリーズ"
      description="配線工事を抑えたい小規模店舗や室内確認など、簡易的な確認用途に向いたWiFi対応カメラシリーズです。"
      tags={['WiFi対応', '4MP', 'microSD対応', 'アプリ対応', '動体検知', '室内向け']}
      features={features}
      locations={['小規模店舗', '個人事務所', '室内簡易確認', '倉庫室内', 'テナント店舗', '玄関周辺']}
      notes={notes}
    />
  );
};

export default WifiCamera;
